export const PROJECT_STATUSES = [
  { value: "en_gestion", label: "En gestión", group: "En gestión", dot: "bg-primary" },
  { value: "en_estudio", label: "En Estudio", group: "En Estudio", dot: "bg-amber-500" },
  { value: "archivado", label: "Archivado", group: "Archivados", dot: "bg-muted-foreground" },
];

export const PROJECT_STATUS_MAP = PROJECT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});

export function statusLabel(value) {
  return PROJECT_STATUS_MAP[value]?.label ?? "En gestión";
}
